module.exports = __webpack_public_path__ + "static/media/thumbnail_GSB_RGB_4x.339123cd.png";